interface FlagProps {
  className?: string;
}

export function FlagBR({ className }: FlagProps) {
  return (
    <svg viewBox="0 0 20 14" className={className} aria-hidden="true">
      <rect width="20" height="14" rx="2" fill="#009C3B" />
      <path d="M10 2 L18 7 L10 12 L2 7 Z" fill="#FFDF00" />
      <circle cx="10" cy="7" r="3" fill="#002776" />
    </svg>
  );
}

export function FlagES({ className }: FlagProps) {
  return (
    <svg viewBox="0 0 20 14" className={className} aria-hidden="true">
      <rect width="20" height="14" rx="2" fill="#AA151B" />
      <rect y="3.5" width="20" height="7" fill="#F1BF00" />
    </svg>
  );
}

export function FlagGB({ className }: FlagProps) {
  return (
    <svg viewBox="0 0 20 14" className={className} aria-hidden="true">
      <rect width="20" height="14" rx="2" fill="#012169" />
      <path d="M0 0 L20 14 M20 0 L0 14" stroke="#FFFFFF" strokeWidth="2.5" />
      <path d="M0 0 L20 14 M20 0 L0 14" stroke="#C8102E" strokeWidth="1" />
      <path d="M10 0 V14 M0 7 H20" stroke="#FFFFFF" strokeWidth="4" />
      <path d="M10 0 V14 M0 7 H20" stroke="#C8102E" strokeWidth="2" />
    </svg>
  );
}
